import script from "./StatusDetailsTabView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatusDetailsTabView.vue?vue&type=script&setup=true&lang=ts"

import "./StatusDetailsTabView.vue?vue&type=style&index=0&id=63141914&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63141914"]])

export default __exports__